export default __webpack_public_path__ + "2bbb3124f031439c8274be4c3299264b.png";